import Table from "Shared/components/DataTable/Table"
import BackdropModal from 'Shared/components/BackdropModal/BackdropModal'
import Button from 'Shared/components/Button'
import restClient from 'Shared/hooks/restClient'
import getDescription from 'CampaignBuilder/components/EditSchedule/getDescription'

export default function CampaignApproval() {
  const [action, setAction] = useState(null)
  const [campaignId, setCampaignId] = useState(null)
  const [scheduledFor, setScheduledFor] = useState(null)

  const hide = () => {
    setAction(null)
    setCampaignId(null)
  }

  const handleTableClick = (e) => {
    if(e.target.classList.contains('approve-campaign-button')) {
      setCampaignId(e.target.dataset.campaignId)
      setScheduledFor(e.target.dataset.scheduledFor)
      setAction('approve')
    }
    if(e.target.classList.contains('reject-campaign-button')) {
      setCampaignId(e.target.dataset.campaignId)
      setScheduledFor(e.target.dataset.scheduledFor)
      setAction('reject')
    }
  }

  const tableProps = {
    table: 'campaignsAwaitingApproval',
    scope: {},
    language: { emptyTable: 'There are no campaigns yet' },
    onClick: handleTableClick,
  }

  const onSubmit = ({ feedback }) => {
    if (action === 'approve') {
      restClient.post(`/api/campaigns/${campaignId}/approve`, { feedback }).then(reloadTable)
    } else {
      restClient.post(`/api/campaigns/${campaignId}/reject`, { feedback }).then(reloadTable)
    }
  }

  const reloadTable = () => {
    window.$('table').DataTable().ajax.reload()
  }

  return <div className="section">
    <div className="box">
      <div>
        <h2 className='no-margin-top'>Campaigns awaiting approval</h2>
      </div>
      <Table {...tableProps} />
      <ConfirmationModal open={!!action} hide={hide} action={action} campaignId={campaignId} onSubmit={onSubmit} scheduledFor={scheduledFor} />
    </div>
  </div>
}

const ConfirmationModal = ({
  open,
  hide,
  action,
  onSubmit,
  scheduledFor
}) => {
  const [feedback, setFeedback] = useState('')
  const disabled = action === 'reject' && feedback.length <= 5

  const handleSubmit = () => {
    if (!disabled) {
      hide()
      onSubmit({ feedback })
    }
  }

  const title = action === 'approve' ? 'Approve campaign' : 'Reject campaign'
  const scheduledFuture = new Date(scheduledFor) > new Date()

  function scheduledMessage() {
    if (!scheduledFor) {
      return "This blast will send immediately once approved. If you want to schedule it, do this first in the campaign builder, then return here to approve."
    } else {
      const scheduledFuture = new Date(scheduledFor) > new Date()
      const formattedScheduledFor = getDescription(scheduledFor)
      if (scheduledFuture) {
        return `This blast is scheduled to send at ${formattedScheduledFor}. Once approved it will send at that time. If you wish to change the schedule, edit the blast before returning here to approve.`
      } else {
        return `This blast was scheduled to send at ${formattedScheduledFor}, which has already passed. Once approved it will send immediately. If you wish to change the schedule, edit the blast before returning here to approve.`
      }
    }
  }

  return (
    <BackdropModal onCancel={hide} open={open} maxWidth="sm" title={title}>
      <div>
        {open && (
          <div className="confirmation-modal__container">
            <p>
              { action === 'approve' && "Optionally provide some feedback for the user." }
              { action === 'reject' && "Explain why you are rejecting the campaign, and provide information on what the user can do to fix it." }
            </p>
            <div className='form-group'>
              <label>Reason</label>
              <textarea onChange={(e) => setFeedback(e.target.value)} value={feedback} className='full-width' />
            </div>
            <div className='margin-top'>
              <strong>{scheduledMessage()}</strong>
            </div>
            <div className="confirmation-modal__action right margin-top">
              <Button red={action === 'reject'} primary={action === 'approve'} disabled={disabled} onClick={handleSubmit}>
                { action === 'approve' && 'Approve' }
                { action === 'reject' && 'Reject' }
              </Button>
            </div>
          </div>
        )}
      </div>
    </BackdropModal>
  )
}

export { ConfirmationModal }
